import { UserSocialId, UserSocialAccountResponse } from '@business/entities/account';
import { Blocs } from '@business/blocs';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { forkJoin, BehaviorSubject, of } from 'rxjs';
import { map, tap, switchMap } from 'rxjs/operators';
import { CalendarAPI } from '@business/api/calendar';
import { ScheduleResponse } from '@business/entities/calendar';
import { SchedularForData } from './AddSchedularModal';
import { UserScheduleResponse } from '@business/entities/account/UserScheduleResponse';

export class AddSchedularModalBloc extends BaseBloc {
  private readonly calendarBloc = resolve(Blocs.calendar);
  private readonly userBloc = resolve(Blocs.user);

  loading = new LoadingState();

  social$ = new BehaviorSubject<UserSocialAccountResponse[]>([]);

  schedules$ = new BehaviorSubject<UserScheduleResponse[]>([]);

  onInit() {
    return CalendarAPI.getSocials().pipe(
      tap(social => this.social$.next(social)),
      this.loading.run(),
    );
  }

  listSchedules = (socialId: UserSocialId) => {
    return CalendarAPI.listSchedule(socialId).pipe(tap(items => this.schedules$.next(items)));
  };

  createSchedule = (socialId: UserSocialId, data: SchedularForData, id?: string) => {
    return CalendarAPI.addSchedule(socialId, data, id).pipe(tap(items => this.schedules$.next(items)));
  };
}
